/* eslint-disable max-params */

/**
 * This is the ObjectMessage type definition for the REST model.
 *
 * @typedef {Object} ObjectMessage
 *
 * @property {ObjectMessageDirection} direction             - Indicates whether a message was sent to or from an object.
 * @property {ObjectMessageCategory|null} messageCategory   - The message category.
 * @property {string} messageId                             - The ID of the object message.
 * @property {Object<string, string>|null} messageParams    - Map of key value pairs with the parameter name as the key (string) and the parameter
 *                                                            value as the value (string), for example key = ‘text’ and value = 'Hello’.
 * @property {ISO8601|null} messageTime                     - Time when the message has been sent to an object or received by Webfleet (ISO8601 format).
 * @property {string|null} messageTextTemplate              - The message text template for STATUS or ORDER messages. Can contain optional placeholders
 *                                                            (for example {$1}), which can be replaced by the value of the corresponding key from ‘messageParams’ (for example ‘1’).
 * @property {string|null} messageType                      - The exact message type. Can be used to create the string code for the corresponding
 *                                                            translation via concatenating ‘wf_msgtype_’ and messageType, for example 'wf_msgtype_20000101’.
 * @property {string} objectId                              - The ID of the object the message was sent to or received from.
 * @property {string|null} sentUserId                       - The ID of the user who sent the message to an object. Is missing if the message has been
 *                                                            received from an object.
 */
export class ObjectMessage {
    constructor(id, direction, category, params, textTemplate, time, type, objectId, sentUserId) {
        this.direction = direction
        this.messageCategory = category
        this.messageId = id
        this.messageParams = params
        this.messageTextTemplate = textTemplate
        this.messageTime = time
        this.messageType = type
        this.objectId = objectId
        this.sentUserId = sentUserId
    }
}
